"use client";

import { useState, useEffect } from "react";
import BlogArticleClient from "./BlogArticleClient";
import { BlogArticleBuddyTour } from "@/components/buddy/BlogArticleBuddyTour";

export default function BlogArticleDynamic({ slug }: { slug: string }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  // BlogArticleBuddyTour activates only when the URL carries
  // ?onboarding_blog_article=1 — for normal article visits it
  // returns null and adds zero overhead.
  return (
    <>
      <BlogArticleBuddyTour />
      <BlogArticleClient slug={slug} />
    </>
  );
}
